import React, { PureComponent } from 'react';
import LabelPromotor from "./LabelPromotor.jsx";
import DataListPromotor from "./DataListPromotor.jsx";

class InputAutoCompletePromotor extends PureComponent {

    render() {
        let promotor;

        const { Validaciones, ValidarPantalla, Cuenta, GET_PROMOTOR, seleccionarCombo, guardarCampoCuenta } = this.props;        
        const { Promotor } = Cuenta;

        if (Cuenta.PromotorId) {
           promotor = <LabelPromotor Promotor={Promotor} guardarCampoCuenta={guardarCampoCuenta} />;
        }
        else {
           promotor = <DataListPromotor GET_PROMOTOR={GET_PROMOTOR} seleccionarCombo={seleccionarCombo} />
        }

        let mensajeError = null;
        if (ValidarPantalla == true) {
            if (Validaciones.PromotorSeleccionado == false) {
                mensajeError = <label className="error">Debe seleccionar un promotor</label>;
            }
        }

        return (
        <div className="bottom-separator-xs">
            <div className="row">
                <div className="col-xs-12">
                    <label className="label-primary">Promotor</label>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-4">
                    {promotor}
                </div>
                <div className="col-xs-12">
                    {mensajeError}
                </div>
            </div>
        </div>
        );
    }
}

export default InputAutoCompletePromotor;